import React from "react";

export default class NoCommentsLightSVG extends React.Component {
  render() {
    return (
      <svg className={this.props.className} viewBox="0 0 147 106" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M56.7686 0.219971V17.032"
          stroke="#94A3B8"
          strokeWidth="0.344086"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M56.7681 88.4216V105.234"
          stroke="#94A3B8"
          strokeWidth="0.344086"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path d="M56.7681 34.8691V35.2132" stroke="#94A3B8" strokeWidth="0.344086" strokeLinecap="round" strokeLinejoin="round" />
        <path
          d="M56.7678 36.5757V72.7529"
          stroke="#94A3B8"
          strokeWidth="0.344086"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeDasharray="0.68 0.68"
        />
        <path d="M56.7681 73.4338V73.7779" stroke="#94A3B8" strokeWidth="0.344086" strokeLinecap="round" strokeLinejoin="round" />
        <path
          d="M109.599 34.8694H3.94441C1.91431 34.8694 0.262695 33.2247 0.262695 31.1877V15.4974C0.262695 13.4673 1.90743 11.8157 3.94441 11.8157H109.599C111.63 11.8157 113.281 13.4604 113.281 15.4974V31.1877C113.274 33.2178 111.63 34.8694 109.599 34.8694Z"
          fill="#F1F5F9"
          stroke="#94A3B8"
          strokeWidth="0.344086"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path d="M81.9555 18.3811H24.4175V22.0559H81.9555V18.3811Z" fill="#94A3B8" />
        <path d="M85.741 24.6294H24.418V28.3042H85.741V24.6294Z" fill="#94A3B8" />
        <path
          d="M18.9672 14.4993H4.96291C3.94441 14.4993 3.12549 15.3251 3.12549 16.3367V30.341C3.12549 31.3595 3.9513 32.1784 4.96291 32.1784H18.9672C19.9857 32.1784 20.8046 31.3526 20.8046 30.341V16.3367C20.8115 15.3251 19.9857 14.4993 18.9672 14.4993Z"
          fill="#94A3B8"
        />
        <path
          d="M109.599 96.8253H3.94441C1.91431 96.8253 0.262695 95.1805 0.262695 93.1435V77.4532C0.262695 75.4231 1.90743 73.7715 3.94441 73.7715H109.599C111.63 73.7715 113.281 75.4162 113.281 77.4532V93.1435C113.274 95.1805 111.63 96.8253 109.599 96.8253Z"
          fill="#F1F5F9"
          stroke="#94A3B8"
          strokeWidth="0.344086"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path d="M81.9555 80.3369H24.4175V84.0118H81.9555V80.3369Z" fill="#94A3B8" />
        <path d="M93.9164 86.5859H24.418V90.2608H93.9164V86.5859Z" fill="#94A3B8" />
        <path
          d="M18.9675 76.4619H4.96315C3.94466 76.4619 3.12573 77.2877 3.12573 78.2993V92.3036C3.12573 93.3221 3.95154 94.1411 4.96315 94.1411H18.9675C19.9859 94.1411 20.8049 93.3153 20.8049 92.3036V78.2993C20.8118 77.2808 19.9859 76.4619 18.9675 76.4619Z"
          fill="#94A3B8"
        />
        <path
          d="M19.0428 95.8759C20.9735 95.8759 22.5387 94.3107 22.5387 92.38C22.5387 90.4492 20.9735 88.884 19.0428 88.884C17.112 88.884 15.5469 90.4492 15.5469 92.38C15.5469 94.3107 17.112 95.8759 19.0428 95.8759Z"
          fill="#F1F5F9"
        />
        <path
          d="M19.0428 95.2902C20.6505 95.2902 21.9538 93.9869 21.9538 92.3792C21.9538 90.7715 20.6505 89.4683 19.0428 89.4683C17.4351 89.4683 16.1318 90.7715 16.1318 92.3792C16.1318 93.9869 17.4351 95.2902 19.0428 95.2902Z"
          fill="#94A3B8"
        />
        <path
          d="M130.141 65.8443H24.4864C22.4563 65.8443 20.8047 64.1996 20.8047 62.1626V46.4722C20.8047 44.4421 22.4494 42.7905 24.4864 42.7905H130.141C132.172 42.7905 133.823 44.4353 133.823 46.4722V62.1626C133.816 64.1996 132.172 65.8443 130.141 65.8443Z"
          fill="#94A3B8"
          stroke="#94A3B8"
          strokeWidth="0.344086"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M119.721 53.0369H127.924"
          stroke="#F1F5F9"
          strokeWidth="0.344086"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M119.721 55.6104H127.924"
          stroke="#F1F5F9"
          strokeWidth="0.344086"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path d="M113.274 49.3625H44.959V53.0374H113.274V49.3625Z" fill="#F1F5F9" />
        <path d="M105.848 55.6111H44.959V59.2859H105.848V55.6111Z" fill="#F1F5F9" />
        <path
          d="M39.5087 45.4807H25.5044C24.4859 45.4807 23.667 46.3065 23.667 47.3181V61.3224C23.667 62.3409 24.4928 63.1599 25.5044 63.1599H39.5087C40.5272 63.1599 41.3461 62.334 41.3461 61.3224V47.3181C41.353 46.3065 40.5272 45.4807 39.5087 45.4807Z"
          fill="#F1F5F9"
        />
        <path
          d="M39.5848 64.8944C41.5155 64.8944 43.0807 63.3292 43.0807 61.3985C43.0807 59.4678 41.5155 57.9026 39.5848 57.9026C37.654 57.9026 36.0889 59.4678 36.0889 61.3985C36.0889 63.3292 37.654 64.8944 39.5848 64.8944Z"
          fill="#94A3B8"
        />
        <path
          d="M39.5846 64.3097C41.1922 64.3097 42.4955 63.0064 42.4955 61.3988C42.4955 59.7911 41.1922 58.4878 39.5846 58.4878C37.9769 58.4878 36.6736 59.7911 36.6736 61.3988C36.6736 63.0064 37.9769 64.3097 39.5846 64.3097Z"
          fill="#F1F5F9"
        />
        <path
          d="M136.547 40.23L145.865 30.9121"
          stroke="#94A3B8"
          strokeWidth="0.344086"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M136.541 42.8313H142.755"
          stroke="#94A3B8"
          strokeWidth="0.344086"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M133.946 40.2569V34.0427"
          stroke="#94A3B8"
          strokeWidth="0.344086"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.2956 59.3471L4.97778 50.0293"
          stroke="#94A3B8"
          strokeWidth="0.344086"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.2952 61.9482H8.08789"
          stroke="#94A3B8"
          strokeWidth="0.344086"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16.897 59.3672V53.1599"
          stroke="#94A3B8"
          strokeWidth="0.344086"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  }
}
